import type { PropsWithChildren } from 'react';
import React from 'react';

import { styledTag } from 'src/utils/styled';

interface ContainerProps {
    $ratio: number;
}
const Container = styledTag('div')`
    position: relative;
    width: 100%;
    ${(props: ContainerProps) => {
        const heightRatio = 1 / props.$ratio;
        return `padding-bottom: ${heightRatio * 100}%`;
    }}
`;

const Inner = styledTag('div')`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

interface Props {
    ratio: number;
}

const AspectRatio: React.FC<PropsWithChildren<Props>> = ({ children, ratio }) => (
    <Container $ratio={ratio}>
        <Inner>{children}</Inner>
    </Container>
);

export default AspectRatio;
